<template>
  <div v-if="showModal" class="mobile-choose-overlay">
    <div class="mobile-choose-container">
      <button class="mobile-choose-close" @click="closeModal">
        <CloseIcon />
      </button>

      <div class="mobile-choose-image">
        <img src="@/assets/img/startup-icon.png" alt="Start Up Show" />
      </div>

      <div class="mobile-choose-div">
        <h2 class="mobile-choose-title">
          <p>{{ $t('mobileAppMessage.title') }}</p>
          <p>{{ $t('mobileAppMessage.title2') }}</p>
        </h2>

        <p class="mobile-choose-subtitle">
          {{ $t('mobileAppMessage.subtitle') }}
        </p>

        <MobileChooseButton :label="$t('mobileAppMessage.forAndroid')" icon="android" @click="() => openLink('android')" />
        <MobileChooseButton :label="$t('mobileAppMessage.forIos')" icon="apple" @click="() => openLink('ios')" />

        <button class="mobile-choose-button-stay" @click="closeModal">
          {{ $t('mobileAppMessage.continue') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CloseIcon from '@/assets/icons/svg/close-gray.svg';
import MobileChooseButton from './MobileChooseButton.vue';

export default {
  name: 'MobileChoose',
  components: {
    CloseIcon,
    MobileChooseButton,
  },
  props: {
    isVisibleMobileModal: Boolean,
    closeModal: Function,
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.auth?.isLoggedIn,
      token: (state) => state.config?.token,
    }),
    showModal() {
      if (this.isLoggedIn && this.token && this.isVisibleMobileModal) {
        return true;
      }

      return false;
    },
  },
  methods: {
    openLink(platform) {
      const links = {
        android: 'https://play.google.com/store/apps/details?id=tv.startupshow.android&pli=1',
        ios: 'https://apps.apple.com/us/app/startup-show/id1483487566',
      };
      window.location.href = links[platform];
    },
  },
};
</script>

<style>
.mobile-choose-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: end;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.mobile-choose-container {
  position: relative;
  background: black;
  width: 100%;
  height: fit-content;
  padding: 32px 16px;
  border-radius: 8px;
  max-width: 400px;
}

.mobile-choose-div {
  display: flex;
  flex-direction: column;
}
.mobile-choose-image {
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  border: 4px solid #202020;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mobile-choose-title {
  margin-top: 32px;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  padding: 0 24px;
  margin-bottom: 8px;
}
.mobile-choose-subtitle {
  font-size: 16px;
  opacity: 0.5;
  text-align: center;
  margin-bottom: 16px;
}
.mobile-choose-button {
  background-color: #0d0b0b;
  border-radius: 12px;
  margin-bottom: 8px;
  padding: 20px 16px;
  border: none;

  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mobile-choose-button p {
  font-size: 16px;
  font-weight: 500;
  color: white;
}
.mobile-choose-button-stay {
  background: transparent;
  border-radius: 12px;
  margin-top: 40px;
  padding: 20px 16px;
  border: 1px solid #ffffff1f;
  font-size: 16px;
  font-weight: 600;
  color: white;
}
.mobile-choose-icon-text {
  display: flex;
  align-items: center;
  gap: 8px;
}
.mobile-choose-close {
  position: absolute;
  right: 16px;
  top: 16px;
  background: transparent;
  border: none;
}
</style>
